import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    BillingPeriod,
    Price,
    PriceStatus,
    PricingModel,
    RecurringOption
} from '../types';
import {useParams} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                               handleCancel,
                           }: {
    record: Omit<Price, 'id'>,
    handleSubmit: (values: Price) => void,
    handleCancel?: () => void
}) => {

    const {id: productId} = useParams()
    if (!productId) {
        throw new Error('productId is required');
    }

    const onSubmit = (values: Price) => {

        values.amount = values.amount * 100;
        values.productId = productId;

        handleSubmit(values);
    };

    const onCancel = () => {
        handleCancel?.();
    };


    let initialValues = {
        recurringOption: RecurringOption.Yes,
        pricingModel: PricingModel.FlatRate,
        billingPeriod: BillingPeriod.Monthly,
        priceStatus: PriceStatus.Active
    } as Price;

    if (record) {
        const pennies = record.amount / 100;
        initialValues = Object.assign({}, initialValues, record, {amount: pennies});
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent {...rest} />
                </FormWithButtons>)}
        </Formik>
    );
};
